import { actionType } from "../actions/kjoretoyTyperActions";
import * as reducerUtils from "../utils/reducerUtils";

const INITIAL_STATE = [];
const kjoretoyTyperReducer = (state = INITIAL_STATE, action) =>
  reducerUtils.CreateNewReducer(state, action, actionType);

export default kjoretoyTyperReducer;
